import React from 'react';
import myImage from './work.jpg';

function About() {
  return (
    <div className="about-page">
      <div className="about-header">
        <h1>Our Story</h1>
      </div>

      <div className="about-section">
        <img src={myImage} 
          alt="Our Workshop" 
          className="about-img" 
        />
        <div className="about-text">
          <p>
            Welcome to <strong>Modern Wear</strong>. We believe that fashion is more than just clothes; 
            it’s an expression of who you are. Founded in 2026, we’ve been 
            committed to providing sustainable and stylish pieces for everyone.
          </p>
          <p>
            Our mission is to bridge the gap between high-end fashion and everyday 
            comfort. Every piece in our shop is hand-selected with care.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;